import { DefaultFooter } from '@ant-design/pro-components';
import React from 'react';

const Footer: React.FC = () => {
  return (
    <DefaultFooter
      style={{
        background: 'none',
      }}
      copyright="2024 Ghostore Admin"
      links={[
        {
          key: 'ghostore',
          title: 'Ghostore',
          href: '#',
          blankTarget: false,
        },
      ]}
    />
  );
};

export default Footer;
